var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "student-management" } }, [
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.doSubmit($event)
          }
        }
      },
      [
        _vm._l(_vm.webConfigs, function(webConfig) {
          return _c(
            "card",
            { key: webConfig.id },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("fg-input", {
                        attrs: {
                          required: true,
                          "for-input": "name",
                          type: webConfig.field,
                          name: webConfig.key_name,
                          id: webConfig.key_name,
                          label: webConfig.name,
                          placeholder: "Masukkan"
                        },
                        model: {
                          value: webConfig.value,
                          callback: function($$v) {
                            _vm.$set(webConfig, "value", $$v)
                          },
                          expression: "webConfig.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        _vm._v(" "),
        _c(
          "card",
          [
            _c("save-data-button", {
              attrs: {
                disabled: _vm.saveButtonData.isLoading,
                "is-create": false,
                state:
                  _vm.saveButtonData.isLoading && _vm.saveButtonData.state === 1
                    ? 2
                    : _vm.saveButtonData.state,
                "is-loading": _vm.saveButtonData.isLoading
              }
            }),
            _vm._v(" "),
            _c("cancel-button")
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a3122d92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3122d92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Settings/WebConfig/Index.vue
// module id = Dcdm
// module chunks = 4